import { useEffect } from 'react';
import queryString from 'query-string';

/**
 * Legacy redirect from /checkin?event=crecer|Auditorio_Principal
 * to the dedicated crecer / servicio check-in routes.
 */
const CheckInRedirect = (props) => {
  useEffect(() => {
    const parsed = queryString.parse(props.location.search);
    const { event, id, eventSN, eventId, ...rest } = parsed;

    if (event === 'crecer') {
      const nextQuery = queryString.stringify({
        ...(id ? { id } : {}),
        ...rest,
      });
      props.history.replace(`/checkin/crecer${nextQuery ? `?${nextQuery}` : ''}`);
      return;
    }

    if (event === 'Auditorio_Principal') {
      const nextQuery = queryString.stringify({
        eventSN: eventSN || 'Auditorio_Principal',
        ...(id ? { id } : {}),
        ...(eventId ? { eventId } : {}),
        ...rest,
      });
      props.history.replace(`/checkin/servicio?${nextQuery}`);
      return;
    }

    props.history.replace('/');
  }, [props.history, props.location.search]);

  return null;
};

export default CheckInRedirect;
